import React from 'react';

function Hamburger() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  );
  /* eslint-enable */
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/common/icons/Hamburger.js